import BasicStats from './BasicStats';

export default BasicStats;
